import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { ClearSmall as Clear } from "@churchofjesuschrist/eden-icons";
import { fontSize11, grey40, grey60, white, lineHeightTight, grey3, spacing16, spacing8, spacing4, spacing24 } from "@churchofjesuschrist/eden-style-constants";
import { marginInlineStart, paddingInlineEnd } from "@churchofjesuschrist/eden-styled-helpers";
const focusColor = "#00A3BB";
const ClearIcon = styled(Clear).withConfig({
  componentId: "a6f33t-0"
})(["", ";min-width:1.375rem;"], marginInlineStart(spacing4));
const tagStyles = css(["background:transparent;border:1px solid ", ";color:", ";font-size:", ";padding:0 ", ";", ";border-radius:0.9375rem;letter-spacing:0.01em;min-height:", ";display:inline-flex;align-items:center;font-weight:400;max-width:18rem;cursor:pointer;line-height:", ";outline:none;", ";&:hover{background:none;", ";}&:active{", ";}&:focus{box-shadow:0px 0px 2px 3px ", ",0px 0px 2px 6px ", ";}&[disabled]{pointer-events:none;opacity:0.5;background:", ";}"], grey40, grey60, fontSize11, spacing16, ({
  showClose
}) => showClose ? paddingInlineEnd(spacing8) : "", spacing24, lineHeightTight, ({
  inverted
}) => inverted ? `border: 1px solid ${white};
   color: ${white};
   background: linear-gradient(330deg, rgba(255, 255, 255, 0.20), rgba(255, 255, 255, 0) 30%)` : `border: 1px solid ${grey40};
   color: ${grey60};
   background: linear-gradient(330deg, rgba(33, 34, 37, 0.15), rgba(255, 255, 255, 0) 30%)`, ({
  inverted
}) => inverted ? `color: ${white};` : `color: ${grey60};`, ({
  inverted
}) => inverted ? `background: linear-gradient(155deg, rgba(255, 255, 255, 0.20), rgba(255, 255, 255, 0) 30%)` : `background: linear-gradient(155deg, rgba(33, 34, 37, 0.15), rgba(255, 255, 255, 0) 30%)`, white, focusColor, grey3);
const Button = styled.button.withConfig({
  componentId: "a6f33t-1"
})(["", ""], tagStyles);
const Link = styled.a.withConfig({
  componentId: "a6f33t-2"
})(["text-decoration:none;", ""], tagStyles);
const Content = styled.span.withConfig({
  componentId: "a6f33t-3"
})(["min-height:calc(", " - 0.125rem);padding:", " 0;"], spacing24, spacing4);

const Tag = ({
  children,
  disabled,
  inverted,
  showClose,
  href,
  ...props
} = {}) => {
  const Component = disabled ? Button : href ? Link : Button;
  return React.createElement(Component, {
    showClose,
    disabled,
    inverted,
    href,
    ...props
  }, children && React.createElement(Content, null, children), showClose && React.createElement(ClearIcon, {
    size: "1rem"
  }));
};

Tag.propTypes = {
  /** Contents inside the tag */
  children: PropTypes.node.isRequired,

  /** Whether the tag is disabled */
  disabled: PropTypes.bool,

  /** Whether to apply styles that help the tag stand out on a dark background */
  inverted: PropTypes.bool,

  /** Whether the close icon should show */
  showClose: PropTypes.bool,

  /** The link that the tag should navigate to on click */
  href: PropTypes.string
};
export default Tag;